import router from "./router";
import store from "./store";
import { getIsWxClient } from "./utils";
import { getUrlParams } from "./utils/url";

const whiteList = ["/404", "/error", "/permission"];

router.beforeEach(async (to, from, next) => {
  const { path, params, query, name } = to;
  console.log(to.path);

  if (whiteList.includes(path)) {
    next();
    return;
  }

  if (store.state.openid) {
    document.title = to.meta.title || "钻立方";
    next();
  } else {
    // if (!getIsWxClient()) {
    //   next("/per");
    //   return;
    // }
    const code = getUrlParams("code") || to.query.code;
    // if (!code) {
    //   next("/error");
    //   return;
    // }
    await store
      .dispatch("getOpenid", code)
      .then((permission) => {
        if (name !== "Boss") {
          const { region, shop } = permission;
          // 运营中心
          if (name === "Operate" && region.length > 0) {
            console.log("operate");
            next();
          } else if (name === "Region" && params.name && shop.length > 0) {
            console.log("region");
            next();
          } else if (name === "Shop" && params.name && shop.length > 0) {
            console.log("shop");
            next();
          } else {
            if (region.length > 0) {
              next("/operate");
            } else if (shop.length > 0) {
              next(`/region/${shop[0].region}`);
            } else {
              next("/permission");
            }
          }
        } else {
          next();
        }
      })
      .catch((err) => {
        next("/permission");
      });
  }
});
